import { Component, OnInit } from '@angular/core';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  showSpinner : boolean = false;

  constructor(
    private spinnerService: SpinnerServiceService
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit(): void {
    this.spinnerService.hideSpinner()
  }

}
